import { z } from 'zod';
export const linkPreviewSchema = z.object({
    url: z.string(),
    title: z.string().nullable(),
    description: z.string().nullable(),
    imageUrl: z.string().nullable(),
    siteName: z.string().nullable(),
});
/** Uzenetenkent ennyi linkbol keszul elonezet - a tobbi csak sima link marad. */
export const MAX_LINK_PREVIEWS_PER_MESSAGE = 3;
const URL_RE = /\bhttps?:\/\/[^\s<>"'\]]+/gi;
/**
 * URL-ek kinyerese egy uzenet szovegebol.
 *
 * A vegen allo irasjeleket levagjuk: a "nezd meg: https://alpha-vet.hu." mondat
 * vegen a pont nem resze a cimnek. A zarojelet csak akkor hagyjuk bent, ha
 * parban all - sok wiki-cim tartalmaz zarojelet.
 */
export function extractUrls(text) {
    const found = text.match(URL_RE) ?? [];
    const result = [];
    for (const raw of found) {
        let url = raw;
        // Zaro irasjelek levagasa a vegerol.
        url = url.replace(/[.,;:!?]+$/, '');
        // Parositlan zaro zarojel levagasa.
        while (url.endsWith(')') && countChar(url, ')') > countChar(url, '(')) {
            url = url.slice(0, -1);
        }
        if (url.length > 2048)
            continue;
        if (!result.includes(url))
            result.push(url);
    }
    return result;
}
const countChar = (value, char) => value.split(char).length - 1;
//# sourceMappingURL=link.js.map